import { render, staticRenderFns } from "./ObjectPlan.vue?vue&type=template&id=3ecb0a28&scoped=true"
import script from "./ObjectPlan.vue?vue&type=script&lang=js"
export * from "./ObjectPlan.vue?vue&type=script&lang=js"
import style0 from "./ObjectPlan.vue?vue&type=style&index=0&id=3ecb0a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb0a28",
  null
  
)

export default component.exports